import React, { useEffect, useRef, useState } from "react";
import { Button, makeStyles } from "@material-ui/core";

import {
  dateConcatenate,
  generateQuickGuid,
  getAccountingJson,
} from "../shared/helpers/helper";

import SaveIcon from "@mui/icons-material/Save";
import { tokens } from "../../theme/tokens";

const useStyle = makeStyles((theme) => ({
  postButton: {
    height: "35px",
    fontSize: ".9em",
    marginTop: "20px",
    width: "150px",
    color: tokens.color.brand.onPrimary,
    backgroundColor: tokens.color.brand.primaryAction,
    textTransform: "capitalize",
    borderRadius: tokens.radius.sm,

    "&:hover": {
      backgroundColor: tokens.color.brand.primaryAction,
      opacity: "0.8",
    },
    "&.Mui-disabled": {
      backgroundColor: tokens.color.surface.subtle,
      color: tokens.color.brand.onPrimary,
    },
  },
  saveButton: {
    height: "35px",
    fontSize: ".9em",
    marginTop: "20px",
    width: "150px",
    color: tokens.color.brand.primaryAction,
    backgroundColor: "transparent",
    border: `1px solid ${tokens.color.brand.primaryAction}`,
    textTransform: "capitalize",
    borderRadius: tokens.radius.sm,
    "&:hover": {
      backgroundColor: tokens.color.surface.hover,
    },
    "&.Mui-disabled": {
      borderColor: tokens.color.border.default,
      color: tokens.color.text.disabled,
    },
  },
  iconStyles: {
    marginRight: "5px",
  },
  buttonRow: {
    marginRight: "2%",
    marginLeft: "2%",
  },
  deleteInvoice: {
    border: `2px solid ${tokens.color.surface.sunken}`,
    "&:hover": {
      color: tokens.color.status.error,
    },
  },
  textAreaInput: {
    "& .MuiInputBase-input": {
      textIndent: "10px",
      textAlign: "left",
    },
    fontSize: "0.9rem",
    fontFamily: tokens.type.family,
    textIndent: "5px",
    marginLeft: "10px",
    marginTop: "12px",
    width: "80%",
    border: `1px solid ${tokens.color.border.default}`,
    color: `${tokens.color.text.primary} !important`,
    borderRadius: tokens.radius.sm,
    backgroundColor: tokens.color.surface.sunken,
  },
}));

function SaveAndGenerateButton({
  values,
  index,
  handleGeneratePDF,
  handleSaveInvoice,
  setFieldValue,
}) {
  const classes = useStyle();
  const [buttonClick, setButtonClick] = useState(false);
  useEffect(() => {
    if (buttonClick) {
      handleGeneratePDF(values, index);
      setButtonClick(false);
    }
  }, [
    values.invoices[index].invoice_details?.invoice_date,
    values.invoices[index].invoice_id,
    buttonClick,
  ]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        columnGap: "16px",
      }}
    >
      <Button
        className={classes.saveButton}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();

          // handle submit for save invoice
          handleSaveInvoice(values, index);
        }}
      >
        <SaveIcon className={classes.iconStyles} /> Save Invoice
      </Button>

      <Button
        className={classes.postButton}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          // handle submit for invoices and generate pdf
          const date = new Date();
          setFieldValue(
            `invoices[${index}].invoice_details.invoice_date`,
            date.toISOString().split("T")[0]
          );

          setFieldValue(
            `invoices[${index}].invoice_id`,
            `${values.invoices[index].file_no}-${dateConcatenate(
              date.toISOString().split("T")[0]
            )}`
          );
          setButtonClick(true);
        }}
      >
        Generate Invoice
      </Button>
    </div>
  );
}

export default SaveAndGenerateButton;
